import { gql } from '@apollo/client';
import PRODUCT from 'api/fragments/PRODUCT';
const RETRIEVE_PRODUCT = gql `
  ${PRODUCT}
  mutation RetrieveProduct($productId: ID!) {
    retrieveProduct(productId: $productId) {
      product {
        ...ProductFragment
      }
    }
  }
`;
export default RETRIEVE_PRODUCT;
